export function extractCatalogTokenFromText(text) {
  const match = String(text || '').match(/\/bot-farmacia\/t\/([^/?#\s]+)/);
  return match?.[1] || '';
}

export function messageReferencesPreviousCatalog(text) {
  return /catálogo personal.*mensaje anterior/i.test(String(text || ''));
}

export function prepareBotMessageText(text) {
  let raw = String(text || '');
  const token = extractCatalogTokenFromText(raw);

  raw = raw.replace(/https?:\/\/[^\s<]+\/bot-farmacia\/t\/[^\s<]+/gi, '');
  raw = raw.replace(
    /🛒 \*Catálogo personal\* \(solo para vos, válido 20 min\):\s*/gi,
    ''
  );
  raw = raw.replace(/Buscá productos, elegí y volvé al chat con un clic\.\s*/gi, '');
  raw = raw.replace(/\n{3,}/g, '\n\n').trim();

  return { text: raw, token };
}
